var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.logoComponent,_vm._b({tag:"component",attrs:{"width":_vm.width,"height":_vm.height}},'component',_vm.logoProps,false))
}
var staticRenderFns = []

export { render, staticRenderFns }